module.exports = __webpack_public_path__ + "img/正方形3.0068ebfe.jpg";